import locations from './datasets/locations';
import unions from './datasets/unions';
import autocomplete from 'autocompleter';
import ages from './datasets/ages';
import Validator from '../validation/Validator';

const datasets = {locations, unions, ages};

export default {
    render(data, event, container) {
        const element = document.createElement('select');
        element.classList.add('form-control');
        element.required = true;

        const dataset = datasets[data.dataset]();
        const state = container.componentList.FirebaseStorage.data();

        const selection = state ? state[data.bind] : null;

        const option = document.createElement('option');
        option.appendChild(document.createTextNode(LanguageManager.getString(
            'selection_placeholder')));
        option.value = '';
        option.disabled = true;
        option.setAttribute('selected', 'true');
        element.appendChild(option);

        Object.entries(dataset).forEach(([key, value]) => {
            const option = document.createElement('option');
            option.appendChild(document.createTextNode(value));
            option.value = key;
            if (key === selection) {
                option.setAttribute('selected', 'true');
            }
            element.appendChild(option);
        });

        return element;
    },
    postRender(element, type, data, container) {
        Logger.info("Snippet.Select", element, type, data, container, event);

        if (data.label) {
            const label = document.createElement('label');
            label.innerText = data.label;
            element.parentElement.insertBefore(label, element);
        }

        const validator = new Validator(data.bind, null, {
            element,
            constraint: {inclusion: datasets[data.bind]}
        });

        const state = container.componentList.FirebaseStorage.data();

        const focusHandler = () => {
            validator.clearHints();
        };

        if(data.logic) {
            const unionsLogic = () => {
                Logger.info("Logic.", element.selectedIndex, element.value, element);

                var nonUnionValues = [
                    "",
                    "not_known",
                    "no_union",
                    "not_listed"
                ];
                
                var sharingCheckbox =  $(document).find("#form_data_share").parent(); // Bad as going to the document directly.
                
                Logger.info("logic",  element.selectedIndex > 0,  nonUnionValues.includes( element.value ) );

                if( nonUnionValues.includes( element.value ) ) {
                    Logger.info("Logic.hide.checkbox");

                   sharingCheckbox.hide();
                } else {
                    Logger.info("Logic.show.checkbox");
                    sharingCheckbox.show();
                }
            }
            unionsLogic();
            element.addEventListener('change', unionsLogic);
        } 

        const validationHandler = () => {
            // state[data.bind] = element.value;

            validator.value(element.value);
            validator.validate();
            if (validator.valid()) {
                // state[data.bind] = element.value;
                // container.componentList.FirebaseStorage.update();
                // console.info("Select.", element)
                container.componentList.FirebaseStorage.setUserProperty(data.bind, element.value);
            }
        };

        // Add the default value
        container.componentList.FirebaseStorage.setUserProperty(data.bind, element.value);

        element.addEventListener('focus', focusHandler);
        element.addEventListener('change', validationHandler);
        element.addEventListener('blur', validationHandler);

        Backbone.listenToOnce( container.session.currentPageData.getBlock(0).view, "onDestroy", (e)=> {
			element.removeEventListener('focus', focusHandler);
            element.removeEventListener('change', validationHandler);
            element.removeEventListener('blur', validationHandler);
		});
    },
};